import { Link, useNavigate, useParams } from 'react-router-dom';
import backicon from '../../../assets/images/back.png';
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createJob, singleJob } from '../../../slices/jobs';
import { clearMessage, setMessageStatus } from '../../../slices/messages';
import { useTranslation } from 'react-i18next';

const CreateJob = () => {
    const { id } = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    let defaultform = {
        title_hi: '',
        title_en: '',
        qualification: '',
        min_salary: '',
        max_salary: '',
        contact_no: '',
        location: '',
        description_en: '',
        description_hi: '',
    };

    const [form, setForm] = useState(defaultform);
    const [submitted, setSubmitted] = useState(0);
    const { message } = useSelector((state) => state.message);
    const { user } = useSelector((state) => state.auth);
    
    const { Status, job } = useSelector((state) => state.jobs);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }
    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        dispatch(clearMessage());
        if (id) {
            dispatch(singleJob(id))
        }
    }, []);
    useEffect(() => {
        if (id) {
            setForm(job);
        }
    }, [job]);

    const handleSubmit = (e) => {
        var inputs = form;
        setSubmitted(1);
        dispatch(createJob(inputs))
            .unwrap()
            .then(() => {
                dispatch(setMessageStatus('Success'));
                navigate("/my-jobs");
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                setSubmitted(0);
            });
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5">
                <div className="row">
                    <div className='col-md-12'>
                        <div className='card form-card bg-2'>
                            <div className='card-header mt-2-5 p-0'>
                                <Link to='/my-posts' className='back-link pl-2-5'>
                                    <img src={backicon} />
                                </Link>
                                <div className='section-title text-center' id='heading_title'>
                                    {
                                        id ?
                                            <h1 className='mb-0'><span className='font-color-1'>{t('editJob')}</span></h1>
                                            :
                                            <h1 className='mb-0'><span className='font-color-1'>{t('postJob')}</span></h1>
                                    }
                                </div>
                            </div>
                            <div className='card-body'>
                                {(message && Status == "Failed") && (
                                    <div className="col-md-12 error-section mt-2-5">
                                        <div
                                            className="alert alert-warning"
                                            role="alert"
                                        >
                                            {message}
                                        </div>
                                    </div>
                                )}

                                <form method="post">
                                    <div className='row mt-2-5'>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('title')} ({t('in_hindi')})</label>
                                            <input type="text" className="form-control" placeholder={t('enter_title')} name='title_hi' onChange={(e) => handleChange(e)} value={form?.title_hi} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('title')} ({t('in_english')})</label>
                                            <input type="text" className="form-control" placeholder={t('enter_title')} name='title_en' onChange={(e) => handleChange(e)} value={form?.title_en} />
                                        </div>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <label>{t('qualification')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_qualification')} name='qualification' onChange={(e) => handleChange(e)} value={form?.qualification} />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('minimum_salary')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_min_salary')} name='min_salary' onChange={(e) => handleChange(e)} value={form?.min_salary} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('maximum_salary')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_max_salary')} name='max_salary' onChange={(e) => handleChange(e)} value={form?.max_salary} />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('contact_no')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_contact')} name='contact_no' onChange={(e) => handleChange(e)} value={form?.contact_no} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('location')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_location')} name='location' onChange={(e) => handleChange(e)} value={form?.location} />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <label>{t('description')} ({t('in_hindi')})</label>
                                            <textarea className='form-control' placeholder={t('enter_description')} name='description_hi' onChange={(e) => handleChange(e)} rows={40} value={form?.description_hi} />
                                        </div>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <label>{t('description')} ({t('in_english')})</label>
                                            <textarea className='form-control' placeholder={t('enter_description')} name='description_en' onChange={(e) => handleChange(e)} rows={40} value={form?.description_en} />
                                        </div>
                                        <div className='col-md-6 m-auto'>
                                            {
                                                submitted ?
                                                    <button type='button' className="btn btn-primary btn-block">{t('please_wait')}</button>
                                                    :
                                                    <button type='button' className="btn btn-primary btn-block" onClick={e => handleSubmit()}>{t('submit')}</button>
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='table-area bg-2 font-color'>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default CreateJob;